$(function () {

  // data_type select
  $('#text_variable_data_type').on('input', function () {
    var val = $(this).val();

    $("[class^='data-format-'], [class*=' data-format-']").hide();
    $('.data-format-' + val).show();
  }).trigger('input');

  // data_format select
  $("select[class^='data-format-'], select[class*=' data-format-']").on('input', function () {
    $('#text_variable_data_format').val($(this).val());
  });

});